import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { DateField, InputField, FileField, CheckboxField } from 'vetrf-ui';
import { ObjectOperation } from 'api/dict/params';
import { BYTE_MAX_LENGTH, KILOBYTE_MAX_LENGTH } from 'utils/consts/consts';
import { FunctionPermissions } from '../../../../../../../types/types';
import { PermitObjectOperation } from '../../../../../../../../types';

type FormFieldsProps = {
  requestFunctions: ObjectOperation[];
  permissions: FunctionPermissions;
  lastStatusDate?: string;
  tempValidDate?: string;
};

export const FormFields = ({
  requestFunctions,
  permissions,
  lastStatusDate,
  tempValidDate,
}: FormFieldsProps) => {
  const { reset, setValue } = useFormContext();
  const operationField = useWatch({
    name: 'operation',
  });

  useEffect(() => {
    reset({ operation: operationField });
    if (operationField?.code === PermitObjectOperation.GRANT) {
      setValue('permissionValidDate', tempValidDate);
    }
  }, [operationField?.code]);

  useEffect(() => {
    if (permissions.patentee) setValue('operation', requestFunctions[0]);
  }, []);

  if (operationField) {
    switch (operationField.code) {
      case PermitObjectOperation.GRANT:
        return (
          <>
            <DateField
              dateFormat="dd.MM.yyyy"
              labelText="Дата изменения статуса"
              locale="ru"
              name="statusDate"
              required="Необходимо заполнить поле"
              validateDateFormat
              comparisonWithCurrentDate={{
                methodOfComparison: 'isSameOrBefore',
              }}
              comparisonWithAnotherDate={
                lastStatusDate && {
                  value: lastStatusDate,
                  methodOfComparison: 'isSameOrAfter',
                }
              }
            />
            <InputField
              labelText="Номер разрешения ЕРУЛ"
              name="permissionNumber"
              required="Необходимо заполнить поле"
              maxLength={BYTE_MAX_LENGTH}
            />
            <DateField
              dateFormat="dd.MM.yyyy"
              labelText="Дата выдачи разрешения ЕРУЛ"
              locale="ru"
              name="permissionDate"
              required="Необходимо заполнить поле"
              validateDateFormat
            />
            <DateField
              dateFormat="dd.MM.yyyy"
              labelText="Срок действия разрешения"
              locale="ru"
              name="permissionValidDate"
              required="Необходимо заполнить поле"
              validateDateFormat
            />
            <CheckboxField labelText="Разрешение на серию/партию" name="permitted" />
          </>
        );
      case PermitObjectOperation.REJECT:
        return (
          <>
            <DateField
              dateFormat="dd.MM.yyyy"
              labelText="Дата изменения статуса"
              locale="ru"
              name="statusDate"
              required="Необходимо заполнить поле"
              validateDateFormat
              comparisonWithCurrentDate={{
                methodOfComparison: 'isSameOrBefore',
              }}
              comparisonWithAnotherDate={
                lastStatusDate && {
                  value: lastStatusDate,
                  methodOfComparison: 'isSameOrAfter',
                }
              }
            />
            <InputField
              labelText="Комментарий"
              name="comment"
              required="Необходимо заполнить поле"
              maxLength={KILOBYTE_MAX_LENGTH}
            />
            <FileField
              name="rejectFile"
              allowMultiple={false}
              labelText="Файл основания для отказа"
              required="Необходимо заполнить поле"
            />
          </>
        );
      case PermitObjectOperation.CHANGE:
        return (
          <>
            {permissions.rshsn && (
              <DateField
                dateFormat="dd.MM.yyyy"
                labelText="Дата изменения статуса"
                locale="ru"
                name="statusDate"
                required="Необходимо заполнить поле"
                validateDateFormat
                comparisonWithCurrentDate={{
                  methodOfComparison: 'isSameOrBefore',
                }}
                comparisonWithAnotherDate={
                  lastStatusDate && {
                    value: lastStatusDate,
                    methodOfComparison: 'isSameOrAfter',
                  }
                }
              />
            )}
            <InputField labelText="Комментарий" name="comment" maxLength={KILOBYTE_MAX_LENGTH} />
          </>
        );
      case PermitObjectOperation.MODIFY:
      case PermitObjectOperation.CHANGED:
      case PermitObjectOperation.EXPIRE:
        return (
          <>
            <DateField
              dateFormat="dd.MM.yyyy"
              labelText="Дата изменения статуса"
              locale="ru"
              name="statusDate"
              required="Необходимо заполнить поле"
              validateDateFormat
              comparisonWithCurrentDate={{
                methodOfComparison: 'isSameOrBefore',
              }}
              comparisonWithAnotherDate={
                lastStatusDate && {
                  value: lastStatusDate,
                  methodOfComparison: 'isSameOrAfter',
                }
              }
            />
            <InputField labelText="Комментарий" name="comment" maxLength={KILOBYTE_MAX_LENGTH} />
          </>
        );
      case PermitObjectOperation.MODIFYED:
      case PermitObjectOperation.NOTCHANGED:
        return (
          <InputField labelText="Комментарий" name="comment" maxLength={KILOBYTE_MAX_LENGTH} />
        );
      default:
        return null;
    }
  }
  return null;
};
